import type { SlotCapacityInfo } from 'noddi-util';
import { formatSupplySeatCounts, secondsToTimeString } from 'noddi-util';

export type { SlotCapacityInfo } from 'noddi-util';

export const hasSlotCapacityToShow = (capacity: SlotCapacityInfo | undefined | null): boolean => {
  if (!capacity) {
    return false;
  }
  if (capacity.totalRemainingSeconds != null) {
    return true;
  }
  return capacity.personalCount > 0 || capacity.baselineCount > 0 || capacity.contributions.length > 0;
};

export const formatSlotCapacitySummary = (capacity: SlotCapacityInfo): string => {
  const remainingSeconds = capacity.totalRemainingSeconds;
  const remainingText =
    remainingSeconds != null
      ? secondsToTimeString({
          seconds: remainingSeconds,
          alwaysIncludeSeconds: false,
          shortFormat: true
        })
      : null;

  const supplyParts = formatSupplySeatCounts(capacity, 'long');

  if (remainingText != null && supplyParts.length > 0) {
    return `${remainingText} remaining · ${supplyParts}`;
  }
  if (remainingText != null) {
    return `${remainingText} remaining`;
  }
  if (supplyParts.length > 0) {
    return supplyParts;
  }
  return 'Availability details';
};
